import React from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';
import { useDialog } from 'hooks/useDialog';
import { useLockedUtkastDialog } from 'hooks/useLockedUtkastDialog';

import DeleteUtkastDialog from 'components/utkast/deleteUtkastDialog/DeleteUtkastDialog';

import { Aktivitet, BebyggelseobjektUtkastIndex } from 'models';

import { AktivitetstypEnum, RegistreringsstatustypEnum } from 'enums';

import classNames from 'classnames';

export const GetUtkastAction = React.memo(
  ({ utkast, aktivitet }: { utkast: BebyggelseobjektUtkastIndex; aktivitet: Aktivitet }) => {
    const { openLockedUtkastDialog } = useLockedUtkastDialog();
    const { setDialog } = useDialog();
    const { data: user } = useAppSelector((state: RootState) => state.user);

    const isReserved: boolean =
      !!utkast.registrering.reservation.reserverad_av_anvandarid &&
      utkast.registrering.reservation.reserverad_av_anvandarid !== user?.username;

    const allowedToDeleteUtkastByAktivitetstyp = [
      AktivitetstypEnum.INVENTERING,
      AktivitetstypEnum.ENKELINVENTERING
    ].includes(aktivitet.aktivitetstyp);

    return (
      <>
        {utkast.registrering.registreringsstatustyp_id === RegistreringsstatustypEnum.REDIGERBAR && (
          <>
            {isReserved && (
              <button
                aria-label={`utkastet är reserverat av ${utkast.registrering.reservation.reserverad_av_anvandarnamn}`}
                className={classNames('raa-icon tw-p-2 tw-text-raa-orange', 'raa-icon-lock-closed')}
                onClick={() => openLockedUtkastDialog(utkast)}
              />
            )}

            {!isReserved && allowedToDeleteUtkastByAktivitetstyp && (
              <button
                aria-label="radera utkast"
                className={classNames('raa-icon tw-p-2 tw-text-raa-orange', 'raa-icon-delete')}
                onClick={() => setDialog(DeleteUtkastDialog, { utkastId: utkast.utkast_id })}
              />
            )}
          </>
        )}
      </>
    );
  }
);

GetUtkastAction.displayName = 'GetUtkastAction';
